import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { format } from 'date-fns';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import PageHeader from '../../../styles/templates/PageHeader';
import Paper from '../../../styles/templates/Paper';
import {
  selectAdminProjectsDate,
  selectAllFilteredProjects,
} from '../../../redux/selectors/adminProjects';
import ProjectTableRow from '../../../components/Projects/ProjectTableRow';
import ProjectTableHeader from '../../../components/Projects/ProjectTableHeader';
import TablePagination from '../../../components/Table/TablePagination/TablePagination';
import { PROJECT_FILTER } from '../../../interfaces/project';
import { useAdminData } from '../../../helpers/customHooks';
import { USER_ROLES } from '../../../constants/roles';

const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.grey[600],
    marginTop: '8px',
  },
}));

const rowsPerPage = 8;

type Props = {
  userRole: USER_ROLES;
};

const CrmProjectsPage: React.FC<Props> = ({ userRole }) => {
  useAdminData();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState<PROJECT_FILTER>(PROJECT_FILTER.EMPTY);
  const [apps, totalApps] = useSelector(selectAllFilteredProjects(filter, page, rowsPerPage));
  const dateFetched = useSelector(selectAdminProjectsDate);
  const classes = useStyles();

  const onFilter = (newFilter: PROJECT_FILTER) => setFilter(newFilter);
  const formattedDate = dateFetched ? format(new Date(dateFetched || ''), 'dd/MM/yy, HH:mm') : '';

  const onProjectClick = (projectId: string) =>
    history.push(`/${userRole === USER_ROLES.ADMIN ? 'admin' : 'manager'}/projects/${projectId}`);

  return (
    <>
      <PageHeader
        title="Projects"
        subtitle="View all projects and use the filters to find results faster"
      />

      <Paper>
        <div>
          <Typography variant="subtitle1">All data, current of {formattedDate}</Typography>
          <Typography variant="body2" className={classes.subtitle}>
            Select each project to see a full information and download forms submitted by
            developers.
          </Typography>
        </div>

        <ProjectTableHeader onFilter={onFilter} selectedFilter={filter} filterStatus />

        {apps.map((app) => (
          <ProjectTableRow
            key={app.application.info.applicationId}
            project={app}
            onClick={onProjectClick}
          />
        ))}

        <TablePagination
          currentPage={page}
          onChangePage={(currentPage) => setPage(currentPage)}
          rowsPerPage={rowsPerPage}
          totalRecords={totalApps}
        />
      </Paper>
    </>
  );
};

export default CrmProjectsPage;
